import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import Header from "@/components/Header";
import Footer from "@/components/Footer";
import MobileCallBar from "@/components/MobileCallBar";
import CallbackWidget from "@/components/CallbackWidget";
import CookieBanner from "@/components/CookieBanner";
import ErrorBoundary from "@/components/ErrorBoundary";

import HomePage from "@/pages/HomePage";
import ServicesPage from "@/pages/ServicesPage";
import OrganisationPage from "@/pages/OrganisationPage";
import MarbreriePage from "@/pages/MarbreriePage";
import PrevoyancePage from "@/pages/PrevoyancePage";
import AvisPage from "@/pages/AvisPage";
import QuiSommesNousPage from "@/pages/QuiSommesNousPage";
import ContactPage from "@/pages/ContactPage";
import MentionsLegalesPage from "@/pages/MentionsLegalesPage";
import ConfidentialitePage from "@/pages/ConfidentialitePage";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <ErrorBoundary>
        <BrowserRouter>
          <ScrollToTop />
          <Header />
          <main data-testid="main-content">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/services" element={<ServicesPage />} />
              <Route path="/organisation" element={<OrganisationPage />} />
              <Route path="/marbrerie" element={<MarbreriePage />} />
              <Route path="/prevoyance" element={<PrevoyancePage />} />
              <Route path="/avis" element={<AvisPage />} />
              <Route path="/qui-sommes-nous" element={<QuiSommesNousPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/mentions-legales" element={<MentionsLegalesPage />} />
              <Route path="/confidentialite" element={<ConfidentialitePage />} />
              <Route path="*" element={<HomePage />} />
            </Routes>
          </main>
          <Footer />
          <MobileCallBar />
          <CallbackWidget />
          <CookieBanner />
          <Toaster position="top-center" richColors closeButton />
        </BrowserRouter>
      </ErrorBoundary>
    </div>
  );
}

export default App;
